'use client'

import React from 'react'
import classNames from 'classnames'
import { useComponentVisible, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { GetContactQuery } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'
import { DigitalData } from '@dustin-web/microsite-components/src/utils/digital-data'
import UserPlusIcon from '@dustin-web/microsite-components/src/icon/generated/user-plus'
import Tooltip from '@dustin-web/microsite-components/src/tooltip'

type Props = {
  contactQueryData?: GetContactQuery | null
  contactQueryError?: Error | null
}
export const AccountMenuRegister = ({ contactQueryData, contactQueryError }: Props) => {
  if (contactQueryError) {
    throw contactQueryError
  }

  const { translate } = useTranslations()
  const { componentRef, isVisible } = useComponentVisible<HTMLLIElement>(false)

  const contact = contactQueryData?.contact

  return (
    <>
      <li
        className={classNames('c-header__user-item c-header__dropdown', {
          'c-header__dropdown--active': isVisible,
        })}
        ref={componentRef}>
        <a
          id="dustin-registration-header-link"
          href="/registration"
          className="c-header__user-btn c-header__dropdown-btn button-stripped"
          onClick={() => DigitalData.createAccountStartHeader()}
          aria-label={translate('Header_Register')}>
          <span className="c-header__user-icon">
            <Tooltip
              popoverLayerClassName="c-header__user-btn--tooltip"
              tooltipText={translate('Header_Register')}>
              <UserPlusIcon name="user-plus" />
            </Tooltip>
          </span>
          <div className="u-relative d-flex flex-column no-mouseflow-dom">
            <div
              className={classNames('c-header__user-title c-header__user-title_md-hidden', {
                'no-mouseflow-dom': contact,
              })}>
              {translate('Header_Register')}
            </div>
          </div>
        </a>
      </li>
    </>
  )
}

export default AccountMenuRegister
